<template>
  <template
    v-for="(seat, seatNumber) in seatsData">
    <AVInstantRunoffSummary
      :rounds="seat.rounds ?? []"
      :sorted-result="sortedResult(seat)"
      :seat-number="seatNumber"
      :quota="seat.quota"
      :total-votes="seat.totalVotes"
      :blank-votes="seat.exclusiveOptionCounts?.blank ?? 0"
      :votes-not-included="votesNotIncluded(seatNumber)"
      :theme="theme"
      :vote-counts="result.voterCounts"
      :locale="locale"
    />
  </template>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { flattenOptions } from "@/entrypoints/shared/contest_utilities";
import type {
  ResultRound,
  ConferenceOption,
  PropType,
  Result,
  ConferenceContest,
  ResultMethod,
  Theme,
  SeatData,
} from '@/types';

export default defineComponent({
  name: "InstantRunoffSummary",
  props: {
    result: {
      type: Object as PropType<Result>,
      required: true,
    },
    contest: {
      type: Object as PropType<ConferenceContest>,
      required: true,
    },
    resultMethod: {
      type: String as PropType<ResultMethod>,
      required: true,
    },
    locale: {
      type: String,
    },
    theme: {
      type: String as PropType<Theme>,
      default: "light",
    },
  },
  computed: {
    seatsData(): SeatData[] {
      const resultData = (this.result as Result).resultData;
      if(resultData.seatsData)
        return resultData.seatsData;
      else
        return [{
          quota: resultData.quota,
          totalVotes: resultData.totalVotes,
          rounds: resultData.rounds,
          elected: resultData.elected,
          eligibleOptions: this.options.map(o => o.reference),
          disabledOptions: resultData.disabledOptions,
          exclusiveOptionCounts: resultData.exclusiveOptionCounts,
        }];
    },
    options() {
      return this.flattenOptions(this.contest.options);
    },
  },
  methods: {
    flattenOptions,
    sortedOptions(seat: SeatData) {
      const sortedOptions = [];
      let elected = {};

      seat.rounds.map((round: ResultRound) => {
        this.options.map((option: ConferenceOption) => {
          if (round.eliminated === option.reference) sortedOptions.unshift(option);
          if (round.elected === option.reference) elected = option;
        });
      });

      // Winner on top no matter in which round was elected
      sortedOptions.unshift(elected);

      return sortedOptions;
    },
    sortedResult(seat: SeatData) {
      return this.sortedOptions(seat).map((option: ConferenceOption) => {
        return {
          reference: option.reference,
          title: option.title,
        }
      });
    },
    votesNotIncluded(index: number) {
      if (this.contest.resultMethod === "multi_seat_instant_runoff") {
        const totals = [];
        this.result.resultData.seatsData.map((seatResult: any) =>
          totals.push(seatResult.totalVotes));
        if (index > 0) return totals[index - 1] - totals[index];
        else return null;
      }
      return null;
    }
  },
});
</script>
